<template>
	<router-link :to="`/messages/list/${this.message.message_id}`" class="list-group-item" :class="containerClass">
		<div class="unread-icon" v-if="!read"></div>
		<p class="mb-0 font-bold" v-if="message.message_subject">{{ message.message_subject }}</p>
		<div class="mb-0">
			<p class="mb-0 font-bold">{{ message.DisplayName }}</p>
			<p class="mb-0" v-if="datetime">{{ datetime }}</p>
		</div>
		<!--<p class="mb-0 italic">Lorem ipsum dolor sit amet...</p>-->
		<div class="mb-0 italic">{{ contentExcerpt }}</div>
	</router-link>
</template>

<script>
export default {
	props: ['message', 'excerptLength'],
	computed: {
		containerClass() {
			if (!this.read) {
				return "message message--unread clearfix";
			}
			return "message clearfix";
		},
		datetime(){
			if(this.message.created){
				var dateObj = this.$datetime.getDateObjectFromDateTimeField(this.message.created);
				if(dateObj){
					return this.$d(dateObj, 'datetime');
				}
				return null;
			}
			return null;
		},
		contentExcerpt() {
			if (this.message.message_content && this.message.message_content.length > this.excerptLength) {
				return this.message.message_content.substring(0, this.excerptLength) + "...";
			}
			return this.message.message_content;
		},
		read() {
			return this.message.message_seen === '1' ? true : false;
		}
	},
};
</script>
